export default "__VITE_ASSET__DFQT5t3L__"